import { getConfig } from '@sortlist-frontend/config';
import { Button, COLORS } from '@sortlist-frontend/design-system/legacy';
import { Trans, useTranslation } from '@sortlist-frontend/translation/ssr';
import Image from 'next/image';

import { OPEN_BRIEFING, useBriefingMessage } from '_components/Briefing/versions/NormalBriefing/BriefingDialog';
import { SectionShape } from '_components/common/SectionShape';
import { projectConfig } from '_features/project/config';

import * as S from './styles';
import { AVAILABLE_COMPANIES } from './utils';

export const Intro = () => {
  const { t } = useTranslation(projectConfig.i18nNamespaces);

  const { sendMessage } = useBriefingMessage();

  const { publicEnv } = getConfig();
  const { s3Bucket: s3BucketUrl } = publicEnv;

  return (
    <div className="overflow-hidden">
      <div className="bg-secondary-900 px-4 py-8 max-sm:py-24 lg:pt-16 lg:pb-8">
        <div className="layout-row layout-align-start-center gap-16 container-lg">
          <div className="flex-1 layout-column layout-align-start-start">
            <S.Title className="text-neutral-100 serif bold">
              <Trans i18nKey="project:new.title_v3">
                Find, match & hire the right provider in 48 hours<span className="text-primary-500">.</span>
              </Trans>
            </S.Title>
            <h6 className="text-secondary-100 lh-3 mt-8 max-sm:mt-4">
              <Trans i18nKey="project:new.subTitle_v3">
                A marketplace of 100,000+ vetted providers where AI & experts <span className="italic bold">match</span>{' '}
                your project with the top four.
              </Trans>
            </h6>
            <Button
              buttonStyle="secondary"
              buttonVariant="raised"
              label={
                <Trans i18nKey="project:new.ctaLabel">
                  Match with a provider <span className="bold italic">- free</span>
                </Trans>
              }
              size="lg"
              className="my-8 max-sm:my-4"
              onClick={() => {
                sendMessage(OPEN_BRIEFING, { cta: 'project-new-hero' });
              }}
              disabled={false}
              data-testid="action-bar-cancel"
            />
            <div className="layout-row layout-align-center-start layout-align-xs-start-center layout-wrap mt-4 gap-4">
              {Object.entries(AVAILABLE_COMPANIES).map(([name, { src, height, width = 80 }]) => (
                <S.LogoImage key={name}>
                  <Image src={src} alt={`${name} logo`} height={height} width={width} />
                </S.LogoImage>
              ))}
            </div>
          </div>
          <div className="hide show-gt-sm flex-none flex-40">
            <Image
              src={`${s3BucketUrl}/illustrations/project-new/find-match-hire.webp`}
              alt={t('project:new.findMatchHireAlt')}
              width={785}
              height={758}
              quality={100}
            />
          </div>
        </div>
      </div>
      <SectionShape className="hide show-gt-sm" color={COLORS.SECONDARY_900} height={80} />
    </div>
  );
};
